/**
 * Register Zoho CRM Integration
 * Registers the Zoho CRM integration with the integration registry
 */

import { integrationRegistry } from '../registry/IntegrationRegistry';
import { zohoCRMIntegrationFactory } from './ZohoCRMIntegrationFactory';

/**
 * Register Zoho CRM integration with the system
 */
export function registerZohoCRMIntegration(): void {
  integrationRegistry.register(
    'crm:zoho',
    'Zoho CRM',
    'crm',
    'zoho',
    '1.0.0',
    zohoCRMIntegrationFactory
  );

  console.log('Zoho CRM integration registered successfully');
}

/**
 * Unregister Zoho CRM integration
 */
export function unregisterZohoCRMIntegration(): void {
  integrationRegistry.unregister('crm:zoho');
  console.log('Zoho CRM integration unregistered');
}

// Auto-register when module is imported
registerZohoCRMIntegration();